import './JobApplicationWithdrawnNote.css';

/**
 * Marks a job whose status reads open (e.g. "P/E PARTIAL APRV") but which BIS's
 * own detail page reports as withdrawn. The date comes from the "JOB WITHDRAWN
 * AS OF <date>" banner, scraped into withdrawn_date, and is why the row counts
 * as resolved despite its status text -- so the reason is surfaced on hover
 * rather than leaving the mismatch unexplained.
 */
function JobApplicationWithdrawnNote({ withdrawnDate }) {
	if (!withdrawnDate) {
		return null;
	}

	return (
		<span
			className="job-application-withdrawn-note"
			title={`Job withdrawn as of ${withdrawnDate}`}
		>
			<i className="bi bi-question-lg" />
		</span>
	);
}

export default JobApplicationWithdrawnNote;
